// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2gytv","header":"styles-module__header___1yofW","label":"styles-module__label___-RI9j"};